module.exports = __webpack_public_path__ + "static/media/Boton_FundacionCS.3f8f5de8.webp";